var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductInfoList',{attrs:{"category":11,"title":'运维设备'}})}
var staticRenderFns = []

export { render, staticRenderFns }